import React, { useEffect } from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import OtpInput from "react-otp-input";
import "./OTPDialog.css";

const DeactivateDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  backdropFilter: "blur(5px)",
  backgroundColor: "rgba(255, 255, 255,0.1)",
}));

export function EnterOTPModal({ open, handleCancel, handleSubmit }) {
  const [otpValue, setOtpValue] = React.useState("");

  // const passOtp = () => {
  //   const otp = otpValue;
  //   console.log("otp : ", otp);
  //   handleSubmit(otp);
  // }

  // const handleOTPChange = (otp) => {
  //   setOtpValue(otp);
  //   handleSubmit(otp);
  // }

  const submitOtp = () => {
    if (otpValue.length === 4) {
      handleSubmit(otpValue);
    } else {
      alert("Please enter the complete 4-digit OTP");
    }
  };

  return (
    <div>
      <DeactivateDialog aria-labelledby="customized-dialog-title" open={open}>
        <DialogContent
          className="deactivateDialogContent"
          style={{
            borderRadius: 5,
            boxShadow: "5px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ padding: 0, margin: 0 }}>
            <h3 className="welcome_text2">Enter 4 Digits Code</h3>
            <p className="welcome_des2">
              Enter the 4 digits code that you received to your updated phone
              number or to your current email
            </p>
          </div>
          <div>
            <OtpInput
              value={otpValue}
              onChange={setOtpValue}
              numInputs={4}
              separator={<span> </span>}
              containerStyle={{ marginBottom: 20 }}
              className="otpTextInput"
              inputStyle={{
                padding: 4,
                border: "1px solid #DDDDDD",
                borderRadius: "8px",
                padding: "10px",
                marginRight: "5px",
                marginLeft: "5px",
                marginTop: "10px",
                color: "#265ED7",
                fontSize: 22,
                fontWeight: "bold",
              }}
              isInputNum={true}
            />
          </div>
          <div
            style={{
              width: "200px",
              paddingBottom: "20px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <DialogActions>
              <Button
                variant="contained"
                type="submit"
                className="payBtn log_submit_btn otp-submit-btn"
                onClick={(e) => {
                  submitOtp();
                }}
                style={{ width: "100%" }}
              >
                Confirm
              </Button>

              <Button variant="text" onClick={handleCancel}>
                Cancel
              </Button>
            </DialogActions>
          </div>
        </DialogContent>
      </DeactivateDialog>
    </div>
  );
}
